module.exports = __webpack_public_path__ + "static/media/review4.f1554686.webp";